module.exports = "/_next/static/images/Criticalillustration-af58ee04c5f3b531a22ff78d3e1f2c9b.svg";